import type { GraphGroup } from './types'

interface Props {
  group: GraphGroup
  x: number
  y: number
  visited: boolean
  focused: boolean
}

/**
 * Composite card — several nodes shown as one unit. Used for the platform
 * engine (thinai-core + Knuckles), which are the same thing from the outside.
 */
export function GroupCard({ group, x, y, visited, focused }: Props) {
  const classes = [
    'tl-group-card',
    focused ? 'tl-group-card--focus' : '',
    group.primary ? 'tl-group-card--primary' : '',
  ]
    .filter(Boolean)
    .join(' ')

  const primary = group.items[0]

  return (
    <div
      className={classes}
      style={{
        left: `${x}%`,
        top: `${y}%`,
        opacity: visited ? 1 : 0.08,
        // The focus ring and pulse keyframe both read --kind-color, so the
        // composite card picks up its lead item's hue with no extra JS.
        ['--kind-color' as string]: primary?.color ?? '#B98CF0',
      }}
      aria-hidden="true"
    >
      <div className="tl-group-card__head">
        <span className="tl-group-card__diamond">◆</span>
        <span className="tl-group-card__tag">{group.tag}</span>
      </div>

      <div className="tl-group-card__items">
        {group.items.map((item) => (
          <div key={item.id} className="tl-group-card__item">
            <span className="tl-group-card__swatch" style={{ background: item.color }} />
            <span className="tl-group-card__item-text">
              <span className="tl-group-card__item-name">{item.name}</span>
              <span className="tl-group-card__item-role">{item.role}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
